import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _643e6d86 = () => interopDefault(import('../app/pages/access-tier/index.vue' /* webpackChunkName: "pages/access-tier/index" */))
const _b6bb1386 = () => interopDefault(import('../app/pages/bestbuy/index.vue' /* webpackChunkName: "pages/bestbuy/index" */))
const _6ac8831e = () => interopDefault(import('../app/pages/device/index.vue' /* webpackChunkName: "pages/device/index" */))
const _411538c0 = () => interopDefault(import('../app/pages/download.vue' /* webpackChunkName: "pages/download" */))
const _f8bf7a86 = () => interopDefault(import('../app/pages/expired.vue' /* webpackChunkName: "pages/expired" */))
const _0fc2f726 = () => interopDefault(import('../app/pages/firstresponder/index.vue' /* webpackChunkName: "pages/firstresponder/index" */))
const _1d55204a = () => interopDefault(import('../app/pages/giftcard/index.vue' /* webpackChunkName: "pages/giftcard/index" */))
const _5053d48f = () => interopDefault(import('../app/pages/invalid.vue' /* webpackChunkName: "pages/invalid" */))
const _b6dd00bc = () => interopDefault(import('../app/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _303b6c68 = () => interopDefault(import('../app/pages/military/index.vue' /* webpackChunkName: "pages/military/index" */))
const _7f34fdc9 = () => interopDefault(import('../app/pages/netiapl.vue' /* webpackChunkName: "pages/netiapl" */))
const _73348572 = () => interopDefault(import('../app/pages/oauth-start/index.vue' /* webpackChunkName: "pages/oauth-start/index" */))
const _31da612e = () => interopDefault(import('../app/pages/pluspl.vue' /* webpackChunkName: "pages/pluspl" */))
const _4a42c308 = () => interopDefault(import('../app/pages/products.vue' /* webpackChunkName: "pages/products" */))
const _2ba11832 = () => interopDefault(import('../app/pages/reset.vue' /* webpackChunkName: "pages/reset" */))
const _7311f29a = () => interopDefault(import('../app/pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _0d863e3c = () => interopDefault(import('../app/pages/store/index.vue' /* webpackChunkName: "pages/store/index" */))
const _7a867f16 = () => interopDefault(import('../app/pages/student/index.vue' /* webpackChunkName: "pages/student/index" */))
const _8b3eba44 = () => interopDefault(import('../app/pages/success/index.vue' /* webpackChunkName: "pages/success/index" */))
const _b0f0314e = () => interopDefault(import('../app/pages/test-deeplink.vue' /* webpackChunkName: "pages/test-deeplink" */))
const _24c02c80 = () => interopDefault(import('../app/pages/vivacombg.vue' /* webpackChunkName: "pages/vivacombg" */))
const _67fc064e = () => interopDefault(import('../app/pages/vodafone.vue' /* webpackChunkName: "pages/vodafone" */))
const _7f4dd7c9 = () => interopDefault(import('../app/pages/voucher/index.vue' /* webpackChunkName: "pages/voucher/index" */))
const _0b6bfed6 = () => interopDefault(import('../app/pages/vt.vue' /* webpackChunkName: "pages/vt" */))
const _1cbda592 = () => interopDefault(import('../app/pages/access-tier/success.vue' /* webpackChunkName: "pages/access-tier/success" */))
const _024a8e7b = () => interopDefault(import('../app/pages/account/changepass.vue' /* webpackChunkName: "pages/account/changepass" */))
const _17bc5088 = () => interopDefault(import('../app/pages/account/updatewallet.vue' /* webpackChunkName: "pages/account/updatewallet" */))
const _adb437a4 = () => interopDefault(import('../app/pages/bestbuy/success.vue' /* webpackChunkName: "pages/bestbuy/success" */))
const _9917281c = () => interopDefault(import('../app/pages/debug/session.vue' /* webpackChunkName: "pages/debug/session" */))
const _48d1c6aa = () => interopDefault(import('../app/pages/device/link.vue' /* webpackChunkName: "pages/device/link" */))
const _64d7d0f1 = () => interopDefault(import('../app/pages/firstresponder/verify/index.vue' /* webpackChunkName: "pages/firstresponder/verify/index" */))
const _3c8ca312 = () => interopDefault(import('../app/pages/giftcard/buy/index.vue' /* webpackChunkName: "pages/giftcard/buy/index" */))
const _5f243877 = () => interopDefault(import('../app/pages/giftcard/return.vue' /* webpackChunkName: "pages/giftcard/return" */))
const _d5fe2368 = () => interopDefault(import('../app/pages/giftcard/success.vue' /* webpackChunkName: "pages/giftcard/success" */))
const _2254569e = () => interopDefault(import('../app/pages/login/mobileapp.vue' /* webpackChunkName: "pages/login/mobileapp" */))
const _1fb58ca4 = () => interopDefault(import('../app/pages/login/playpl.vue' /* webpackChunkName: "pages/login/playpl" */))
const _5aa718c1 = () => interopDefault(import('../app/pages/login/reset.vue' /* webpackChunkName: "pages/login/reset" */))
const _f02e8f22 = () => interopDefault(import('../app/pages/login/tidal/index.vue' /* webpackChunkName: "pages/login/tidal/index" */))
const _1e800896 = () => interopDefault(import('../app/pages/military/verify/index.vue' /* webpackChunkName: "pages/military/verify/index" */))
const _2c1d988b = () => interopDefault(import('../app/pages/oauth-start/return.vue' /* webpackChunkName: "pages/oauth-start/return" */))
const _21e551a9 = () => interopDefault(import('../app/pages/order/return.vue' /* webpackChunkName: "pages/order/return" */))
const _4f6927f7 = () => interopDefault(import('../app/pages/sheerid/search.vue' /* webpackChunkName: "pages/sheerid/search" */))
const _85cdb0ea = () => interopDefault(import('../app/pages/signup/redirect.vue' /* webpackChunkName: "pages/signup/redirect" */))
const _afcfa1b8 = () => interopDefault(import('../app/pages/signup/success.vue' /* webpackChunkName: "pages/signup/success" */))
const _6de59394 = () => interopDefault(import('../app/pages/store/return.vue' /* webpackChunkName: "pages/store/return" */))
const _2a093628 = () => interopDefault(import('../app/pages/student/verify/index.vue' /* webpackChunkName: "pages/student/verify/index" */))
const _7229d1ff = () => interopDefault(import('../app/pages/success/awin.vue' /* webpackChunkName: "pages/success/awin" */))
const _056fc288 = () => interopDefault(import('../app/pages/v1/health.vue' /* webpackChunkName: "pages/v1/health" */))
const _7ec5fc0d = () => interopDefault(import('../app/pages/voucher/trial.vue' /* webpackChunkName: "pages/voucher/trial" */))
const _9cf6b838 = () => interopDefault(import('../app/pages/firstresponder/verify/return/index.vue' /* webpackChunkName: "pages/firstresponder/verify/return/index" */))
const _7caaaafc = () => interopDefault(import('../app/pages/giftcard/buy/details.vue' /* webpackChunkName: "pages/giftcard/buy/details" */))
const _244b2df0 = () => interopDefault(import('../app/pages/giftcard/buy/preview.vue' /* webpackChunkName: "pages/giftcard/buy/preview" */))
const _369623a7 = () => interopDefault(import('../app/pages/login/tidal/custom/index.vue' /* webpackChunkName: "pages/login/tidal/custom/index" */))
const _5ecc36b6 = () => interopDefault(import('../app/pages/login/tidal/handover.vue' /* webpackChunkName: "pages/login/tidal/handover" */))
const _06ca2ae8 = () => interopDefault(import('../app/pages/login/tidal/partner/index.vue' /* webpackChunkName: "pages/login/tidal/partner/index" */))
const _ca0bfb3a = () => interopDefault(import('../app/pages/login/tidal/return.vue' /* webpackChunkName: "pages/login/tidal/return" */))
const _c0bb0ec2 = () => interopDefault(import('../app/pages/military/verify/return/index.vue' /* webpackChunkName: "pages/military/verify/return/index" */))
const _9e8e0962 = () => interopDefault(import('../app/pages/order/login/return.vue' /* webpackChunkName: "pages/order/login/return" */))
const _0b4842cd = () => interopDefault(import('../app/pages/student/verify/return/index.vue' /* webpackChunkName: "pages/student/verify/return/index" */))
const _7c0c03aa = () => interopDefault(import('../app/pages/login/tidal/custom/return.vue' /* webpackChunkName: "pages/login/tidal/custom/return" */))
const _1f94eb64 = () => interopDefault(import('../app/pages/login/tidal/partner/order.vue' /* webpackChunkName: "pages/login/tidal/partner/order" */))
const _0f7241ec = () => interopDefault(import('../app/pages/login/tidal/partner/return.vue' /* webpackChunkName: "pages/login/tidal/partner/return" */))
const _4b604ee0 = () => interopDefault(import('../app/pages/login/tidal/partner/vodafone.vue' /* webpackChunkName: "pages/login/tidal/partner/vodafone" */))
const _d5727bb4 = () => interopDefault(import('../app/pages/giftcard/buy/success/_orderid.vue' /* webpackChunkName: "pages/giftcard/buy/success/_orderid" */))
const _4992bfb0 = () => interopDefault(import('../app/pages/sheerid/verification/callback/_requestId.vue' /* webpackChunkName: "pages/sheerid/verification/callback/_requestId" */))
const _76a9fa8c = () => interopDefault(import('../app/pages/firstresponder/return/_sessionid.vue' /* webpackChunkName: "pages/firstresponder/return/_sessionid" */))
const _7a1bc207 = () => interopDefault(import('../app/pages/military/return/_sessionid.vue' /* webpackChunkName: "pages/military/return/_sessionid" */))
const _66aff6ae = () => interopDefault(import('../app/pages/partner/plusupsellcallback/_transactionid.vue' /* webpackChunkName: "pages/partner/plusupsellcallback/_transactionid" */))
const _6710bdf4 = () => interopDefault(import('../app/pages/playlist/migration/_uuid.vue' /* webpackChunkName: "pages/playlist/migration/_uuid" */))
const _cd46caee = () => interopDefault(import('../app/pages/sheerid/verification/_partnername.vue' /* webpackChunkName: "pages/sheerid/verification/_partnername" */))
const _1ccf9dac = () => interopDefault(import('../app/pages/sheerid/verify/_verifyid.vue' /* webpackChunkName: "pages/sheerid/verify/_verifyid" */))
const _012b8096 = () => interopDefault(import('../app/pages/student/return/_sessionid.vue' /* webpackChunkName: "pages/student/return/_sessionid" */))
const _152e1259 = () => interopDefault(import('../app/pages/campaigns/_campaignId/index.vue' /* webpackChunkName: "pages/campaigns/_campaignId/index" */))
const _6733212a = () => interopDefault(import('../app/pages/device/_code.vue' /* webpackChunkName: "pages/device/_code" */))
const _4bcf3b05 = () => interopDefault(import('../app/pages/donate/_slug/index.vue' /* webpackChunkName: "pages/donate/_slug/index" */))
const _89142ba6 = () => interopDefault(import('../app/pages/partner/_orderreference.vue' /* webpackChunkName: "pages/partner/_orderreference" */))
const _74f72a06 = () => interopDefault(import('../app/pages/signup/_partnername/index.vue' /* webpackChunkName: "pages/signup/_partnername/index" */))
const _2db6f0a6 = () => interopDefault(import('../app/pages/campaigns/_campaignId/products.vue' /* webpackChunkName: "pages/campaigns/_campaignId/products" */))
const _d4b6c33a = () => interopDefault(import('../app/pages/campaigns/_campaignId/rememberLogin.vue' /* webpackChunkName: "pages/campaigns/_campaignId/rememberLogin" */))
const _e8f4b53e = () => interopDefault(import('../app/pages/donate/_slug/form.vue' /* webpackChunkName: "pages/donate/_slug/form" */))
const _383496f6 = () => interopDefault(import('../app/pages/donate/_slug/success.vue' /* webpackChunkName: "pages/donate/_slug/success" */))
const _1a20cc5a = () => interopDefault(import('../app/pages/signup/_partnername/echo-headers.vue' /* webpackChunkName: "pages/signup/_partnername/echo-headers" */))
const _416d05ea = () => interopDefault(import('../app/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4337b6e4 = () => interopDefault(import('../app/pages/_code.vue' /* webpackChunkName: "pages/_code" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/access-tier",
    component: _643e6d86,
    name: "access-tier"
  }, {
    path: "/bestbuy",
    component: _b6bb1386,
    name: "bestbuy"
  }, {
    path: "/device",
    component: _6ac8831e,
    name: "device"
  }, {
    path: "/download",
    component: _411538c0,
    name: "download"
  }, {
    path: "/expired",
    component: _f8bf7a86,
    name: "expired"
  }, {
    path: "/firstresponder",
    component: _0fc2f726,
    name: "firstresponder"
  }, {
    path: "/giftcard",
    component: _1d55204a,
    name: "giftcard"
  }, {
    path: "/invalid",
    component: _5053d48f,
    name: "invalid"
  }, {
    path: "/logout",
    component: _b6dd00bc,
    name: "logout"
  }, {
    path: "/military",
    component: _303b6c68,
    name: "military"
  }, {
    path: "/netiapl",
    component: _7f34fdc9,
    name: "netiapl"
  }, {
    path: "/oauth-start",
    component: _73348572,
    name: "oauth-start"
  }, {
    path: "/pluspl",
    component: _31da612e,
    name: "pluspl"
  }, {
    path: "/products",
    component: _4a42c308,
    name: "products"
  }, {
    path: "/reset",
    component: _2ba11832,
    name: "reset"
  }, {
    path: "/signup",
    component: _7311f29a,
    name: "signup"
  }, {
    path: "/store",
    component: _0d863e3c,
    name: "store"
  }, {
    path: "/student",
    component: _7a867f16,
    name: "student"
  }, {
    path: "/success",
    component: _8b3eba44,
    name: "success"
  }, {
    path: "/test-deeplink",
    component: _b0f0314e,
    name: "test-deeplink"
  }, {
    path: "/vivacombg",
    component: _24c02c80,
    name: "vivacombg"
  }, {
    path: "/vodafone",
    component: _67fc064e,
    name: "vodafone"
  }, {
    path: "/voucher",
    component: _7f4dd7c9,
    name: "voucher"
  }, {
    path: "/vt",
    component: _0b6bfed6,
    name: "vt"
  }, {
    path: "/access-tier/success",
    component: _1cbda592,
    name: "access-tier-success"
  }, {
    path: "/account/changepass",
    component: _024a8e7b,
    name: "account-changepass"
  }, {
    path: "/account/updatewallet",
    component: _17bc5088,
    name: "account-updatewallet"
  }, {
    path: "/bestbuy/success",
    component: _adb437a4,
    name: "bestbuy-success"
  }, {
    path: "/debug/session",
    component: _9917281c,
    name: "debug-session"
  }, {
    path: "/device/link",
    component: _48d1c6aa,
    name: "device-link"
  }, {
    path: "/firstresponder/verify",
    component: _64d7d0f1,
    name: "firstresponder-verify"
  }, {
    path: "/giftcard/buy",
    component: _3c8ca312,
    name: "giftcard-buy"
  }, {
    path: "/giftcard/return",
    component: _5f243877,
    name: "giftcard-return"
  }, {
    path: "/giftcard/success",
    component: _d5fe2368,
    name: "giftcard-success"
  }, {
    path: "/login/mobileapp",
    component: _2254569e,
    name: "login-mobileapp"
  }, {
    path: "/login/playpl",
    component: _1fb58ca4,
    name: "login-playpl"
  }, {
    path: "/login/reset",
    component: _5aa718c1,
    name: "login-reset"
  }, {
    path: "/login/tidal",
    component: _f02e8f22,
    name: "login-tidal"
  }, {
    path: "/military/verify",
    component: _1e800896,
    name: "military-verify"
  }, {
    path: "/oauth-start/return",
    component: _2c1d988b,
    name: "oauth-start-return"
  }, {
    path: "/order/return",
    component: _21e551a9,
    name: "order-return"
  }, {
    path: "/sheerid/search",
    component: _4f6927f7,
    name: "sheerid-search"
  }, {
    path: "/signup/redirect",
    component: _85cdb0ea,
    name: "signup-redirect"
  }, {
    path: "/signup/success",
    component: _afcfa1b8,
    name: "signup-success"
  }, {
    path: "/store/return",
    component: _6de59394,
    name: "store-return"
  }, {
    path: "/student/verify",
    component: _2a093628,
    name: "student-verify"
  }, {
    path: "/success/awin",
    component: _7229d1ff,
    name: "success-awin"
  }, {
    path: "/v1/health",
    component: _056fc288,
    name: "v1-health"
  }, {
    path: "/voucher/trial",
    component: _7ec5fc0d,
    name: "voucher-trial"
  }, {
    path: "/firstresponder/verify/return",
    component: _9cf6b838,
    name: "firstresponder-verify-return"
  }, {
    path: "/giftcard/buy/details",
    component: _7caaaafc,
    name: "giftcard-buy-details"
  }, {
    path: "/giftcard/buy/preview",
    component: _244b2df0,
    name: "giftcard-buy-preview"
  }, {
    path: "/login/tidal/custom",
    component: _369623a7,
    name: "login-tidal-custom"
  }, {
    path: "/login/tidal/handover",
    component: _5ecc36b6,
    name: "login-tidal-handover"
  }, {
    path: "/login/tidal/partner",
    component: _06ca2ae8,
    name: "login-tidal-partner"
  }, {
    path: "/login/tidal/return",
    component: _ca0bfb3a,
    name: "login-tidal-return"
  }, {
    path: "/military/verify/return",
    component: _c0bb0ec2,
    name: "military-verify-return"
  }, {
    path: "/order/login/return",
    component: _9e8e0962,
    name: "order-login-return"
  }, {
    path: "/student/verify/return",
    component: _0b4842cd,
    name: "student-verify-return"
  }, {
    path: "/login/tidal/custom/return",
    component: _7c0c03aa,
    name: "login-tidal-custom-return"
  }, {
    path: "/login/tidal/partner/order",
    component: _1f94eb64,
    name: "login-tidal-partner-order"
  }, {
    path: "/login/tidal/partner/return",
    component: _0f7241ec,
    name: "login-tidal-partner-return"
  }, {
    path: "/login/tidal/partner/vodafone",
    component: _4b604ee0,
    name: "login-tidal-partner-vodafone"
  }, {
    path: "/giftcard/buy/success/:orderid?",
    component: _d5727bb4,
    name: "giftcard-buy-success-orderid"
  }, {
    path: "/sheerid/verification/callback/:requestId?",
    component: _4992bfb0,
    name: "sheerid-verification-callback-requestId"
  }, {
    path: "/firstresponder/return/:sessionid?",
    component: _76a9fa8c,
    name: "firstresponder-return-sessionid"
  }, {
    path: "/military/return/:sessionid?",
    component: _7a1bc207,
    name: "military-return-sessionid"
  }, {
    path: "/partner/plusupsellcallback/:transactionid?",
    component: _66aff6ae,
    name: "partner-plusupsellcallback-transactionid"
  }, {
    path: "/playlist/migration/:uuid?",
    component: _6710bdf4,
    name: "playlist-migration-uuid"
  }, {
    path: "/sheerid/verification/:partnername?",
    component: _cd46caee,
    name: "sheerid-verification-partnername"
  }, {
    path: "/sheerid/verify/:verifyid?",
    component: _1ccf9dac,
    name: "sheerid-verify-verifyid"
  }, {
    path: "/student/return/:sessionid?",
    component: _012b8096,
    name: "student-return-sessionid"
  }, {
    path: "/campaigns/:campaignId",
    component: _152e1259,
    name: "campaigns-campaignId"
  }, {
    path: "/device/:code",
    component: _6733212a,
    name: "device-code"
  }, {
    path: "/donate/:slug",
    component: _4bcf3b05,
    name: "donate-slug"
  }, {
    path: "/partner/:orderreference?",
    component: _89142ba6,
    name: "partner-orderreference"
  }, {
    path: "/signup/:partnername",
    component: _74f72a06,
    name: "signup-partnername"
  }, {
    path: "/campaigns/:campaignId?/products",
    component: _2db6f0a6,
    name: "campaigns-campaignId-products"
  }, {
    path: "/campaigns/:campaignId?/rememberLogin",
    component: _d4b6c33a,
    name: "campaigns-campaignId-rememberLogin"
  }, {
    path: "/donate/:slug?/form",
    component: _e8f4b53e,
    name: "donate-slug-form"
  }, {
    path: "/donate/:slug?/success",
    component: _383496f6,
    name: "donate-slug-success"
  }, {
    path: "/signup/:partnername/echo-headers",
    component: _1a20cc5a,
    name: "signup-partnername-echo-headers"
  }, {
    path: "/",
    component: _416d05ea,
    name: "index"
  }, {
    path: "/:code",
    component: _4337b6e4,
    name: "code"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
